import { Component } from '@angular/core';
import { LaunchpadUser } from '../../../models/launchpad-user';
import { Application } from 'src/app/admin/models/application';

@Component({
    selector: 'app-user-roles-slideout',
    templateUrl: './user-roles-slideout.component.html',
    styleUrls: ['../../user-slideout.component.sass'],
    standalone: false
})
export class UserRolesSlideoutComponent {
  loading: boolean = true;
  user: LaunchpadUser | null = null;

  get applications(): Application[] {
    return this.user?.apps?.filter(a => a.roles != null && a.roles.length > 0) ?? [];
  }
}
